import { MessageBar, MessageBarBody, makeStyles, tokens } from '@fluentui/react-components';
import { PortalUserType } from '@powerportalspro/core';
import { AuthStatus, RecordContext, useAuth, useT } from '@powerportalspro/react';
import {
  EditorLabelPosition,
  ImageEdit,
  MenuBar,
  RefreshContextButton,
  SaveContextButton,
} from '@powerportalspro/react-fluent';
import { useCurrentContactId } from './AccountAndContactCustomViews';

// The signed-in visitor's own contact photo: choose one, save, and it is their contact's image in
// Dataverse. A visitor who isn't signed in as a portal user can still choose and preview an
// image, on a new record of the demo table everyone may edit, which is never saved.

const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Demos.ImageEditor.ImageEditorMainDemo';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalMNudge,
  },
  editor: {
    maxWidth: '480px',
  },
});

export function ImageEditorMainSample() {
  const styles = useStyles();
  const t = useT();
  const auth = useAuth();
  // The signed-in portal user's contact; null for a visitor, or an internal user, who has none.
  const contactId = useCurrentContactId();

  if (auth.status === AuthStatus.Loading) return null;

  if (contactId !== null) {
    return (
      <RecordContext table="contact" id={contactId} warnOnUnsavedChanges={false}>
        <div className={styles.root}>
          <MenuBar>
            <SaveContextButton />
            <RefreshContextButton />
          </MenuBar>
          <div className={styles.editor}>
            <ImageEdit
              columnName="entityimage"
              displayImage
              editAfterUpload
              labelPosition={EditorLabelPosition.Above}
              label={t(`${STRINGS_BASE}.photo-label`)}
            />
          </div>
        </div>
      </RecordContext>
    );
  }

  const isInternalUser =
    auth.status === AuthStatus.Authenticated &&
    auth.user.portalUserType === PortalUserType.SystemUser;

  return (
    <div className={styles.root}>
      <MessageBar intent="info" layout="multiline">
        <MessageBarBody>
          {t(`${STRINGS_BASE}.${isInternalUser ? 'internal-user' : 'sign-in-to-save'}`)}
        </MessageBarBody>
      </MessageBar>
      {/* No id: a new record, and with no save button it is never saved. */}
      <RecordContext table="ppp_democustomtable" warnOnUnsavedChanges={false}>
        <div className={styles.editor}>
          <ImageEdit
            columnName="ppp_primaryimage"
            displayImage
            editAfterUpload
            labelPosition={EditorLabelPosition.Above}
            label={t(`${STRINGS_BASE}.photo-label`)}
          />
        </div>
      </RecordContext>
    </div>
  );
}
